"use strict";
import Account from "../api/account";
import classNames from "classnames";
import presenceService from "./presence_service_next_gen";
import { History } from "react-router";
import ToDashboardWithFilters from "./ui/to_dashboard_with_filters";
import Honeybadger from "@honeybadger-io/js";
var PresenceList = React.createClass({
  mixins: [History],
  getInitialState: function() {
    return {
      hasAlertedForDuplicatePresence: false,
      hidden: false,
      users: this.getList()
    };
  },
  componentDidMount: function() {
    $(presenceService).on("presence_service:updated", this.updateList);
    this.updateList();
  },
  componentDidUpdate: function() {
    if (this.flowMode() && this.state.users.filter((x) => x.name !== presenceService.user.name && x.name !== presenceService.user.display_name).length > 0) {
      this.alertForDuplicatePresence();
    }
  },
  componentWillUnmount: function() {
    $(presenceService).off("presence_service:updated", this.updateList);
  },
  alertForDuplicatePresence: function() {
    if (!this.state.hasAlertedForDuplicatePresence) {
      Honeybadger.notify(
        "Flow Mode - Duplicate Presence",
        {
          context: {
            batchId: this.props.batchId,
            currentUser: {
              id: presenceService.user.id,
              name: presenceService.user.name,
              displayName: presenceService.user.display_name
            },
            emailId: this.props.emailId,
            loadId: this.props.loadId,
            path: this.props.location.pathname,
            users: this.state.users
          },
          message: `${this.state.users.length} users detected`
        }
      );
      this.setState({ hasAlertedForDuplicatePresence: true });
    }
  },
  getList: function() {
    return presenceService.getOtherUsers(this.props);
  },
  updateList: function() {
    this.setState({ users: this.getList() });
  },
  hide: function() {
    if (!this.props.inline) {
      this.setState({ hidden: true });
    }
  },
  show: function(e) {
    this.setState({ hidden: false });
    e.stopPropagation();
  },
  flowMode: function() {
    if (this.props.location && this.props.location.query) {
      const onDone = this.props.location.query.onDone || "";
      return onDone.includes("inFlowMode=true") || onDone.includes("newFlowMode");
    }
    return false;
  },
  redirectToDashboard: function() {
    ToDashboardWithFilters(this.props.location, this.history);
  },
  render: function() {
    if (this.state.users.length === 0) {
      return /* @__PURE__ */ React.createElement("div", null);
    }
    var whoClasses = classNames({
      "presence__who": true,
      "hidden": this.state.hidden,
      "presence__carrier": this.props.carrierId
    });
    var linkClasses = classNames({
      "presence__link": true,
      "hidden": this.state.hidden
    });
    var showClasses = classNames({
      "presence__show": true,
      "visible": this.state.hidden
    });
    var containerClasses = classNames({
      "presence__container": !this.props.inline,
      "presence__container--inline": this.props.inline
    });
    if (this.props.className) {
      containerClasses += " " + this.props.className;
    }
    return /* @__PURE__ */ React.createElement("div", { className: containerClasses }, /* @__PURE__ */ React.createElement("div", { className: whoClasses, onClick: this.hide }, this.viewedByText(), ":\xA0", _.map(this.state.users, function(u) {
      return u.name;
    }).join(", ")), /* @__PURE__ */ React.createElement("div", { className: linkClasses, onClick: this.redirectToDashboard }, this.flowMode() ? "Skip to Next Item" : "Back to Dashboard"), /* @__PURE__ */ React.createElement(
      "div",
      {
        className: showClasses,
        onClick: this.show
      },
      "+"
    ));
  },
  viewedByText: function() {
    return this.props.carrierId ? Account.carrierTerm() + " viewed by" : "Currently viewed by";
  }
});
export default PresenceList;
